import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import { HomeSectionTitle } from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';

export function HomeCreate({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-create.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeCreate.Title',
                '<strong>Built-in uploading, recording, and editing tools</strong> so you can easily create and publish episodes.',
                'Anchor home page creation tools section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#creation" onClick={onClickCTA}>
            {t(
              'HomePage.HomeCreate.CreationFeaturesLinkText',
              'See all creation features',
              'Anchor home page creation features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <MarketingImage
          width={520}
          height={520}
          imagePath="home/creation/create"
          alt={t(
            'HomePage.HomeCreate.CreationImageAlt',
            'A picture of a group of women recording a podcast outdoors',
            'Anchor home page creation image screenreader information'
          )}
        />
      }
    />
  );
}
